import React from 'react'

export default () => {
  return (
    <div> 
        <div className="site-content" style={{height:'70vh'}}>
        <div className="p-4">
            <div className="site-content-body">
            <div className="welcome-content d-flex flex-column align-items-center justify-content-center m-auto">
                <img src={require("../../assets/img/rolling-ads-logo.png")} alt="" className="mw-100" />
                <p className="blue-clr fs-4">Enable Location Services within "Settings".</p>
            </div>
            </div>
        </div>
    </div>

    </div>
  )
}
